<template>
    <div class="dashboard__cards">
        <div class="card card--with-heading">
            <div class="chart-wrapper">
                <h4 class="card-header">
                    <div class="card-title">Precios</div>
                    <div class="content-at-right">
                        <div class="we-toggle-text">
                            <div
                                :class="{
                                    active: !showOnlyDeliveryAtDestinationData,
                                }"
                                @click="
                                    showOnlyDeliveryAtDestinationData = false
                                "
                            >
                                Origen
                            </div>
                            <div
                                :class="{
                                    active: showOnlyDeliveryAtDestinationData,
                                }"
                                @click="
                                    showOnlyDeliveryAtDestinationData = true
                                "
                            >
                                Destino
                            </div>
                        </div>
                    </div>
                    <!-- Precio de la ultima operacion capon/MEI -->
                    <div class="last-operation" v-if="lastMeiOperationFinished">
                        Precio de la última operacion capón o MEI con entrega en
                        {{
                            showOnlyDeliveryAtDestinationData
                                ? "destino"
                                : "origen"
                        }}
                        concretada:
                        <b>${{ lastMeiOperationFinished }}</b>
                    </div>
                </h4>
                <div v-show="isLoading">
                    <div
                        id="div-with-loading"
                        class="vs-con-loading__container"
                    >
                        Loading...
                    </div>
                </div>

                <apexchart
                    v-show="!isLoading && !noData"
                    ref="boxPlotChartComponent"
                    type="boxPlot"
                    :options="chartOptions"
                    :series="series"
                ></apexchart>
                <div v-show="noData" class="alert info">
                    <vs-icon icon="info"></vs-icon>
                    <span
                        >No existe suficiente información para mostrar los
                        precios con
                        <b>
                            entrega en
                            {{
                                showOnlyDeliveryAtDestinationData
                                    ? "destino"
                                    : "origen"
                            }}</b
                        >.</span
                    >
                </div>
            </div>
        </div>
    </div>
</template>



<script>
import axios from "axios";
import { print } from "graphql";
import lastOperation from "../../graphql/queries/lastOperation.gql";
import VueApexCharts from "vue-apexcharts";

export default {
    name: "box-plot-chart",
    components: {
        apexchart: VueApexCharts,
    },
    components: {
        apexchart: VueApexCharts,
    },
    props: {
        graphData: Object,
        barSize: {
            type: String,
            required: true,
        },
        isLoading: {
            type: Boolean,
            default: true,
            required: false,
        },
    },
    data() {
        return {
            lastMeiOperationFinished: "",
            lastOperationsFullData: [],
            noData: false,
            showOnlyDeliveryAtDestinationData: true,
            series: [
                {
                    name: "Precios",
                    type: "boxPlot",
                    data: [],
                },
            ],
            realSeries: [{ data: [] }],
            chartOptions: {
                legend: {
                    show: false,
                },
                chart: {
                    id: "boxplot-prices",
                    width: "100%",
                    type: "boxPlot",
                    height: 350,
                    locales: [
                        {
                            name: "es",
                            options: {
                                toolbar: {
                                    exportToSVG: "Descargar SVG",
                                    exportToPNG: "Descargar PNG",
                                    exportToCSV: "Descargar CSV",
                                    menu: "Menu",
                                },
                            },
                        },
                    ],
                    zoom: {
                        enabled: false,
                    },
                    defaultLocale: "es",
                    toolbar: { show: false },
                },
                yaxis: {
                    labels: {
                        formatter: (value) => {
                            return value != null ? value.toFixed(0) : null;
                        },
                    },
                    min: undefined,
                    max: undefined,
                },
                xaxis: {
                    type: "category",
                    tickPlacement: "between",
                },
                tooltip: {
                    custom: ({ series, seriesIndex, dataPointIndex, w }) => {
                        // Esta funcion se tiene que hacer con una arrow function porque sino no tiene acceso al this
                        let data = this.realSeries[0].data[dataPointIndex];

                        if (data.y[2] == null) return ``;
                        return `
                          <span style="padding: 10px">
                            Maximo:   <b>  $${data.y[4].toFixed(2)} </b><br>
                            Promedio: <b>  $${data.y[2].toFixed(2)} </b><br>
                            Minimo:   <b>  $${data.y[0].toFixed(2)} </b><br>
                          </span>
                        `;
                    },
                },
                plotOptions: {
                    boxPlot: {
                        colors: {
                            upper: "#3d92d9",
                            lower: "#3d92d9",
                        },
                    },
                    bar: {
                        columnWidth: "10%",
                    },
                },
                fill: {
                    opacity: 1,
                },
            },
        };
    },
    mounted() {
        this.$vs.loading({
            container: "#div-with-loading",
            scale: 1,
            background: "white",
        });

        axios
            .get(`${process.env.VUE_APP_GRAPH_PATH}`, {
                params: {
                    query: print(lastOperation),
                    variables: {
                        currentUserToken: localStorage.getItem("USER_TOKEN"),
                    },
                },
            })
            .then((res) => {
                if (res.data.errors) {
                    return;
                }
                // Recordatorio: 0 Global - 1 Entrega origen - 2 Entrega destino
                this.lastOperationsFullData = res.data.data.lastOperation;
                if (this.showOnlyDeliveryAtDestinationData) {
                    this.lastMeiOperationFinished =
                        this.lastOperationsFullData[2].price;
                } else {
                    this.lastMeiOperationFinished =
                        this.lastOperationsFullData[1].price;
                }
            });
    },
    methods: {
        redrawChart() {
            // Es importante que las nuevas opciones sean un objeto nuevo
            // y no esten asignados por referencia.
            let newOptions = { ...this.chartOptions };

            // Updatea los colores de la gráfica según si se está mostrando entrega en destino u origen:
            newOptions.plotOptions.boxPlot.colors = {
                upper: this.showOnlyDeliveryAtDestinationData
                    ? "#3d92d9"
                    : "#d1746f",
                lower: this.showOnlyDeliveryAtDestinationData
                    ? "#4697d8"
                    : "#e07c78",
            };

            newOptions.colors = this.showOnlyDeliveryAtDestinationData
                ? ["#3d92d9"]
                : ["#d1746f"];

            // Updatea el ancho de las barras segun la cantidad de datos que haya.
            newOptions.plotOptions.bar.columnWidth = this.barSize;

            this.$refs.boxPlotChartComponent.updateOptions(
                newOptions,
                true,
                true
            );
        },

        MapDataToGraph(graphData) {
            let newSeries = graphData.marketGraphDashboard.graphValues.map(
                (obj) => {
                    let strObj = obj.week.toString();
                    let x = `${strObj.substring(0, 4)}-${strObj.substring(
                        4,
                        6
                    )} `;

                    let y = [];
                    // La Y será el minimo, promedio y máximo. Además, se agregaran los Cuartiles,
                    // pero estos serán falsos porque es la mitad de la media y el maximo/minimo.

                    if (this.showOnlyDeliveryAtDestinationData) {
                        y = [
                            obj.deliveryAtDestinationMinPrice,
                            obj.deliveryAtDestinationMinPrice,
                            obj.deliveryAtDestinationAvgPrice,
                            obj.deliveryAtDestinationMaxPrice,
                            obj.deliveryAtDestinationMaxPrice,
                        ];
                    } else {
                        y = [
                            obj.deliveryAtOriginMinPrice,
                            obj.deliveryAtOriginMinPrice,
                            obj.deliveryAtOriginAvgPrice,
                            obj.deliveryAtOriginMaxPrice,
                            obj.deliveryAtOriginMaxPrice,
                        ];
                    }
                    return { x, y };
                }
            );

            let purgeAll0Data = newSeries.map((e) => {
                if (e.y.every((el) => el == 0)) {
                    return {
                        x: e.x,
                        y: [
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                        ],
                    };
                } else {
                    return e;
                }
            });

            // this.series tiene guardada la serie para graficar.
            // this.realSeries tiene la serie original, para mostrar los datos en el tooltip
            // this.series se modifica para tener un largo minimo.

            this.series[0].data = purgeAll0Data;
            this.realSeries[0].data = { ...this.series[0].data };

            // El offset de los cuadros va a ser un 5% del tamaño de la grafica, pero con un maximo de 10.
            let offSet = Math.min(
                (this.chartOptions.yaxis.max - this.chartOptions.yaxis.min) *
                    0.02
            );

            this.series[0].data = this.series[0].data.map((e) => {
                if (typeof e.y[2] != "undefined") {
                    let newY = [
                        Math.min(e.y[2] - offSet, e.y[0]),
                        Math.min(e.y[2] - offSet, e.y[0]),
                        e.y[2],
                        Math.max(e.y[2] + offSet, e.y[4]),
                        Math.max(e.y[2] + offSet, e.y[4]),
                    ];

                    return {
                        x: e.x,
                        y: newY,
                    };
                } else {
                    return e;
                }
            });

            let mainData = this.series[0].data.map((serie) => serie.y);
            this.noData =
                mainData.flat().filter((e) => e != null || e != undefined)
                    .length < 1;

            this.redrawChart();
        },
    },
    watch: {
        showOnlyDeliveryAtDestinationData() {
            this.MapDataToGraph(this.graphData);

            this.lastMeiOperationFinished = this
                .showOnlyDeliveryAtDestinationData
                ? this.lastOperationsFullData[2].price
                : this.lastOperationsFullData[1].price;
        },
        graphData: function (newVal, oldVal) {
            // Calculo el maximo valor del eje Y segun los valores maximos de
            // la data. Se necesitan el valor de ambos.
            const allData = [...newVal.marketGraphDashboard.graphValues];
            const maxYAxisValue = Math.max(
                ...allData.map((e) =>
                    Math.max(
                        e.deliveryAtDestinationMaxPrice,
                        e.deliveryAtOriginMaxPrice
                    )
                )
            );
            let minYAxisValue = Math.min(
                ...allData.map((e) => {
                    if (
                        e.deliveryAtDestinationMinPrice > 0 &&
                        e.deliveryAtOriginMinPrice > 0
                    ) {
                        return Math.min(
                            e.deliveryAtDestinationMinPrice,
                            e.deliveryAtOriginMinPrice
                        );
                    } else if (e.deliveryAtOriginMinPrice > 0) {
                        return e.deliveryAtOriginMinPrice;
                    } else if (e.deliveryAtDestinationMinPrice > 0) {
                        return e.deliveryAtDestinationMinPrice;
                    } else {
                        return Infinity;
                    }
                })
            );
            if (minYAxisValue == Infinity) {
                minYAxisValue = 0;
            }

            this.chartOptions.yaxis.min = Math.max(
                0,
                minYAxisValue - (maxYAxisValue - minYAxisValue) * 0.03
            );

            this.chartOptions.yaxis.max =
                maxYAxisValue + (maxYAxisValue - minYAxisValue) * 0.03;

            // En el caso de que el maximo y el minimo coincidan, hay que hacer otra cosa
            // Porque sino se traba en un solo valor.
            if (minYAxisValue == maxYAxisValue) {
                this.chartOptions.yaxis.max = maxYAxisValue + 10;
                this.chartOptions.yaxis.min = maxYAxisValue - 10;
            }

            if (newVal && newVal.marketGraphDashboard) {
                this.MapDataToGraph(newVal);
            }
        },
    },
};
</script>

<style scoped>
#div-with-loading {
    width: 300px;
    height: 300px;
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
}
.content-at-right {
    text-align: right;
    margin-left: auto;
    z-index: 1;
}
.card-header {
    margin-left: -16px;
    flex-wrap: wrap;
}

.last-operation {
    width: 100%;
    font-weight: 400;
    font-size: 14px;
    position: absolute;
    top: 25px;
    z-index: 0;
}
@media (max-width: 768px) {
    .last-operation {
        position: relative;
        margin-top: 10px;
        top: 0;
    }
}
</style>
